import { RefObject, useLayoutEffect, useState } from 'react'
import useResizeObserverSsr from './useResizeObserverSsr'

export const useSize = (target: RefObject<HTMLHtmlElement | null>) => {
  const [size, setSize] = useState<DOMRectReadOnly | undefined>()

  useLayoutEffect(() => {
    if (target.current) {
      setSize(target.current.getBoundingClientRect())
    }
  }, [target])

  // Where the magic happens

  useResizeObserverSsr(target, (entry) => setSize(entry.contentRect))
  return size
}